var map = {
	"./arrow-down.svg": "896a",
	"./books": "ca52",
	"./books.json": "ca52",
	"./closeIcon.svg": "ceb4",
	"./fonts/source-code-pro-v22-latin-300.eot": "f7e5",
	"./fonts/source-code-pro-v22-latin-300.svg": "97f8",
	"./fonts/source-code-pro-v22-latin-300.ttf": "fd89",
	"./fonts/source-code-pro-v22-latin-300.woff": "4f1c",
	"./fonts/source-code-pro-v22-latin-300.woff2": "b8ca",
	"./fonts/source-code-pro-v22-latin-600.eot": "d8d3",
	"./fonts/source-code-pro-v22-latin-600.svg": "3cd5",
	"./fonts/source-code-pro-v22-latin-600.ttf": "a2f0",
	"./fonts/source-code-pro-v22-latin-600.woff": "5e7a",
	"./fonts/source-code-pro-v22-latin-600.woff2": "156f",
	"./fonts/source-code-pro-v22-latin-regular.eot": "824a",
	"./fonts/source-code-pro-v22-latin-regular.svg": "456e",
	"./fonts/source-code-pro-v22-latin-regular.ttf": "3a32",
	"./fonts/source-code-pro-v22-latin-regular.woff": "d19e",
	"./fonts/source-code-pro-v22-latin-regular.woff2": "3272",
	"./fonts/source-sans-pro-v21-latin-300.eot": "bb3f",
	"./fonts/source-sans-pro-v21-latin-300.svg": "1151",
	"./fonts/source-sans-pro-v21-latin-300.ttf": "4dcb",
	"./fonts/source-sans-pro-v21-latin-300.woff": "d5f9",
	"./fonts/source-sans-pro-v21-latin-300.woff2": "7333",
	"./fonts/source-sans-pro-v21-latin-600.eot": "0401",
	"./fonts/source-sans-pro-v21-latin-600.svg": "c928",
	"./fonts/source-sans-pro-v21-latin-600.ttf": "ae6d",
	"./fonts/source-sans-pro-v21-latin-600.woff": "8829",
	"./fonts/source-sans-pro-v21-latin-600.woff2": "0f7b",
	"./fonts/source-sans-pro-v21-latin-700.eot": "b692",
	"./fonts/source-sans-pro-v21-latin-700.svg": "1b72",
	"./fonts/source-sans-pro-v21-latin-700.ttf": "c9e5",
	"./fonts/source-sans-pro-v21-latin-700.woff": "b7fe",
	"./fonts/source-sans-pro-v21-latin-700.woff2": "4947",
	"./fonts/source-sans-pro-v21-latin-regular.eot": "3e18",
	"./fonts/source-sans-pro-v21-latin-regular.svg": "2362",
	"./fonts/source-sans-pro-v21-latin-regular.ttf": "5c2a",
	"./fonts/source-sans-pro-v21-latin-regular.woff": "bd0f",
	"./fonts/source-sans-pro-v21-latin-regular.woff2": "f807",
	"./gfa.jpg": "b8f9",
	"./heart.svg": "fbe8",
	"./menu.svg": "36be",
	"./nt.jpg": "3fe1",
	"./ou.jpg": "9979",
	"./tel.jpg": "4505",
	"./wg.jpg": "2862"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";